import Caption from '@algbra/ui/components/Caption/Caption'
import { Column, Container, Row } from '@algbra/ui/components/Grid/Grid'
import Heading from '@algbra/ui/components/Heading/Heading'
import Whitespace from '@algbra/ui/components/Whitespace/Whitespace'
import { map } from 'rambdax'
import styles from './ColumnContentList.module.scss'

export type ColumnContent = {
  id: string
  title: string
  summary?: string
}
export type ZoneColumnContentListProps = {
  __typename: 'StrapiGQL_ComponentZonesColumnContentList'
  title: string
  list: ColumnContent[]
}

export default function ZoneColumnContentList(
  props: ZoneColumnContentListProps
): JSX.Element {
  const { title, list } = props
  return (
    <Whitespace type="md" title={title}>
      <Container>
        <Heading level={2} type="lg" className={styles.title}>
          {title}
        </Heading>
        <Row gutter={false} className={styles.row}>
          {map(
            ({ id, title }) => (
              <Column
                key={`column-${id}`}
                size={12}
                sm={6}
                lg={4}
                className={styles.column}
              >
                <div className={styles.content}>
                  <Caption type="lg" className={styles.item}>
                    {title}
                  </Caption>
                </div>
              </Column>
            ),
            list || []
          )}
        </Row>
      </Container>
    </Whitespace>
  )
}
